<template>
  <div v-loading="loading"
       class="dashboard-area">
    <div class="dashboard-area--title flex justify-between">
      <div class="flex align-center">
        <span>广告报告</span>
        <gj-help style="margin-left: 10px;">
          <div>数据来源：亚马逊广告 业务报告；</div>
          <div>计算公式：商品广告数据+展示广告数据+品牌广告数据；</div>
          <div>使用说明：由于品牌广告无法找到商品，所以广告报告比“查看更多”页面中数据多出品牌广告部分的数据，无法精准核对。</div>
        </gj-help>
        <i @click="$gjQuery" class="iconfont iconshuaxin"></i>
        <span class="color666 size12">数据更新时间：{{updateTime}}</span>
      </div>

<!--      <span v-if="date" class="panel-time">-->
<!--        {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}-->
<!--      </span>-->
      <div class="dashboard-area--rt-link">
        <gj-link :route-to="moreLink" class="color666">查看更多 ></gj-link>
      </div>
    </div>

    <div class="flex">

      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          :title="'广告花费'+(data.currencySymbol?`(${data.currencySymbol})`:'')"
          :number="amountSymbol(data.summary.adsCost)"
          :compareNumber="amountSymbol(data.summary.adsCost-data.previousPeriodSummary.adsCost)"
          width="20%"
          @click="selectChart('adsCost', '广告花费')"
          :active="type === 'adsCost'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          商品广告花费：{{data.sp.adsCost | defaultShow(data.currencySymbol)}}<br>
          展示广告花费：{{data.sd.adsCost | defaultShow(data.currencySymbol)}}<br>
          品牌广告花费：{{data.sb.adsCost | defaultShow(data.currencySymbol)}}<br>
          总广告花费：{{data.summary.adsCost | defaultShow(data.currencySymbol)}}<br>
        </template>
      </gj-card>

      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          :title="'广告销售额'+(data.currencySymbol?`(${data.currencySymbol})`:'')"
          :number="amountSymbol(data.summary.adsSales)"
          :compareNumber="amountSymbol(data.summary.adsSales-data.previousPeriodSummary.adsSales)"
          width="20%"
          @click="selectChart('adsSales', '广告销售额')"
          :active="type === 'adsSales'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          商品广告销售额：{{data.sp.adsSales | defaultShow(data.currencySymbol)}}<br>
          展示广告销售额：{{data.sd.adsSales | defaultShow(data.currencySymbol)}}<br>
          品牌广告销售额：{{data.sb.adsSales | defaultShow(data.currencySymbol)}}<br>
          总广告销售额：{{data.summary.adsSales | defaultShow(data.currencySymbol)}}<br>
        </template>
<!--        <template #title>-->
<!--          <gj-help :left="'4px'">广告投入产出比=广告花费/广告销售额</gj-help>-->
<!--        </template>-->
      </gj-card>

      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="广告订单量"
          :number="defaultShow(data.summary.adsOrders)"
          :compareNumber="defaultShow(data.summary.adsOrders-data.previousPeriodSummary.adsOrders)"
          width="20%"
          @click="selectChart('adsOrders', '广告订单量')"
          :active="type === 'adsOrders'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          商品广告订单量：{{data.sp.adsOrders | defaultShow}}<br>
          展示广告订单量：{{data.sd.adsOrders | defaultShow}}<br>
          品牌广告订单量：{{data.sb.adsOrders | defaultShow}}<br>
          总广告订单量：{{data.summary.adsOrders | defaultShow}}<br>
        </template>
        <!--        <template #title>-->
        <!--          <gj-help :left="'4px'">广告投入产出比=广告花费/广告销售额</gj-help>-->
        <!--        </template>-->
      </gj-card>

      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="点击量"
          :number="defaultShow(data.summary.adsClicks)"
          :compareNumber="defaultShow(data.summary.adsClicks-data.previousPeriodSummary.adsClicks)"
          width="20%"
          @click="selectChart('adsClicks', '点击量')"
          :active="type === 'adsClicks'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          商品广告点击量：{{data.sp.adsClicks | defaultShow}}<br>
          展示广告点击量：{{data.sd.adsClicks | defaultShow}}<br>
          品牌广告点击量：{{data.sb.adsClicks | defaultShow}}<br>
          总广告点击量：{{data.summary.adsClicks | defaultShow}}<br>
        </template>
        <!--        <template #title>-->
        <!--          <gj-help :left="'4px'">广告投入产出比=广告花费/广告销售额</gj-help>-->
        <!--        </template>-->
      </gj-card>

      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="ACOS"
          :number="defaultShow(data.summary.acos)"
          :compareNumber="defaultShow((data.summary.acos-data.previousPeriodSummary.acos).toFixed(2))"
          suffix="%"
          width="20%"
          @click="selectChart('acos', 'ACOS')"
          :active="type === 'acos'"
          :isNumberColumn="clientWidth <= 1600"
      >
        <template #title>
          <gj-help :left="'4px'">广告投入产出比=广告花费/广告销售额</gj-help>
        </template>
      </gj-card>

<!--      <gj-card-->
<!--          height="100px"-->
<!--          tabCard-->
<!--          title="ACOAS"-->
<!--          :number="defaultShow(data.summary.acoas,'', '%')"-->
<!--          width="20%"-->
<!--          @click="selectChart('acoas', 'ACOAS')"-->
<!--          :active="type === 'acoas'"-->
<!--      >-->
<!--        <template #title>-->
<!--          <gj-help :left="'4px'">广告花费占总销售额比例=广告花费/总销售额</gj-help>-->
<!--        </template>-->
<!--      </gj-card>-->
<!--      <gj-card-->
<!--          height="100px"-->
<!--          tabCard-->
<!--          title="ASOAS"-->
<!--          :number="defaultShow(data.summary.asoas ,'', '%')"-->
<!--          width="20%"-->
<!--          @click="selectChart('asoas', 'ASOAS')"-->
<!--          :active="type === 'asoas'"-->
<!--      >-->
<!--        <template #title>-->
<!--          <gj-help :left="'4px'">广告销售额占总销售额占比=广告销售额/总销售额</gj-help>-->
<!--        </template>-->
<!--      </gj-card>-->
    </div>

    <div ref="chart" class="report-chart"></div>
  </div>
</template>

<script>
  import {getAdReport} from "../../../../../api/dashboard";
  import {convertToDate, convertToFullDate, dateShortcut} from "../../../../../utils/date.util";
  import {countryMarketParams, isMeaningful, isMeaningless} from "../../../../../utils/common";

  import {amountSymbol,defaultShow} from "@/filters";
  import {dashboardMixin, queryMixin} from "@/minxins";
  import {mapGetters} from "vuex";

  export default {
    name: "app-dashboard-ad-report",
    mixins: [queryMixin, dashboardMixin],
    props: {
      date: {
        required: true
      },
      dateType: null,// 日期类型，自定义时间传''，近7天seven/近14天fourteen/近30天thirty/本周week/本月month
    },
    data() {
      return {
        loading: false,
        chart: null,
        type: '',
        data: {
          summary:{},
          previousPeriodSummary:{},

          previousPeriodChartList:[],
          sp:{},
          sb:{},
          sd:{}
        },
        updateTime:convertToFullDate(new Date(),"yyyy-MM-dd hh:mm:ss"),
        activeType: 'adsCost',
        activeName: '广告花费'
      }
    },
    computed: {
      startDate() {
        if(this.dateType===''){
          return this.date ? convertToDate(this.date[0]) : '';
        }else {
          return this.data.chartList? this.data.chartList[0].statisticsDate : '';
        }
      },
      endDate() {
        if(this.dateType===''){
          return this.date ? convertToDate(this.date[1]) : '';
        }else {
          return this.data.chartList? this.data.chartList[this.data.chartList.length-1].statisticsDate : '';
        }
      },
      dateShortcut() {
        return dateShortcut(this.date);
      },
      moreLink() {
        return `/ad/asin-analysis?startDate=${this.startDate}&endDate=${this.endDate}`
      },
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      $gjQuery(){
        if(!this.showAdMask){
          return
        }
        // 缓存了时区时，第一次不请求
        if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
          return
        }
        this.loading = true;
        // 构造查询参数
        const params = {
          currency: this.dashboardCurrency,// 币种
          dateType: this.dateType, // 日期类型，自定义时间传''，近7天seven/近14天fourteen/近30天thirty/本周week/本月month
          dateTime: this.timezoneText,// 站点时间
          startDate: this.startDate,
          endDate: this.endDate,
          ...countryMarketParams(this.countryMarket),

        };
        getAdReport(params)
            .then((data) => {
              this.data = {
                ...data,
                sp: data.summaryByType ? data.summaryByType.find(r=>r.adType === 0) : {},
                sb: data.summaryByType ? data.summaryByType.find(r=>r.adType === 1) : {},
                sd: data.summaryByType ? data.summaryByType.find(r=>r.adType === 2) : {},
              };
              this.updateTime = convertToFullDate(new Date(),"yyyy-MM-dd hh:mm:ss")
              this.selectChart(this.activeType, this.activeName)
            })
            .complete(() => this.loading = false);
      },
      amountSymbol,
      defaultShow,
      selectLinesChart(type, typeNames, typeValues) {
        if (isMeaningless(this.data)) {
          return;
        }
        this.type = type;
        this.chart.setOption({
          legend: {
            data: typeNames,
          },
          xAxis: {
            data: this.data.previousPeriodChartList.map(item => item.showDate),
          },
          series: [
            {
              name: typeNames[0],
              type: 'line',
              data: this.data.chartList.map(item => ({
                value: item[typeValues[0]] || 0,
                prefix: item.currencySymbol,
                suffix: '',
                statisticsDate: item.statisticsDate,
                data: item
              }))
            },
            {
              name: typeNames[1],
              type: 'line',
              data: this.data.previousPeriodChartList.map(item => ({
                value: item[typeValues[1]] || 0,
                prefix: item.currencySymbol,
                suffix: '',
                statisticsDate: item.statisticsDate,
                data: item
              }))
            },
            {
              name: typeNames[2],
              type: 'line',
              data: this.data.chartList.map(item => ({
                value: item[typeValues[2]] || 0,
                prefix: item.currencySymbol,
                suffix: '',
                statisticsDate: item.statisticsDate,
                data: item,
              }))
            },
            {
              name: typeNames[3],
              type: 'line',
              data: this.data.previousPeriodChartList.map(item => ({
                value: item[typeValues[3]] || 0,
                prefix: item.currencySymbol,
                suffix: '',
                statisticsDate: item.statisticsDate,
                data: item
              }))
            }
          ]
        });
      },
      selectChart(type, typeName) {
        this.activeType = type;
        this.activeName = typeName;
        if (isMeaningless(this.data)) {
          return;
        }
        this.type = type;
        const showCurrencySymbol = ['广告花费', '广告销售额'].includes(typeName);
        this.chart.setOption({
          legend: {
            data: [typeName, `同期${typeName}`],
          },
          xAxis: {
            data: this.data.chartList.map(item => item.statisticsDate),
          },
          series: [
            {
              name: typeName,
              type: 'line',
              showSymbol: false,
              symbol:'circle',
              data: this.data.chartList.map(item => ({
                value: item[type] || 0,
                statisticsDate: item.statisticsDate,
                prefix: showCurrencySymbol ? this.data.currencySymbol : '',
                suffix: typeName==='ACOS'?'%':'',
              }))
            },
            {
              name: `同期${typeName}`,
              type: 'line',
              showSymbol: false,
              symbol:'circle',
              data: this.data.previousPeriodChartList.map(item => ({
                value: item[type] || 0,
                statisticsDate: item.statisticsDate,
                prefix: showCurrencySymbol ? this.data.currencySymbol : '',
                suffix: typeName==='ACOS'?'%':'',
              }))
            },
            // {
            //   data: [],
            // },
            // {
            //   data: [],
            // }
          ]
        });
      },
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          this.chart = this.$echarts.init(chartRef);
          const option = {
            color: ["#409EFF", "#67C23A", "rgb(158, 135, 255)", "rgb(115, 221, 255)"],
            tooltip: {
              trigger: 'axis',
              axisPointer:{
                z:0
              },
              formatter: function (e) {
                // 基础数据
                const data = [];
                const periodData = [];
                e.forEach(item => {
                  if (item.seriesName.includes('同期')) {
                    if (periodData.length === 0) {
                      periodData.push(`${item.data.statisticsDate}`);
                    }
                    periodData.push(`${item.seriesName}：${item.data.prefix}${item.data.value}${item.data.suffix}`);
                  } else {
                    if (data.length === 0) {
                      data.push(`${item.data.statisticsDate}`);
                    }
                    data.push(`${item.seriesName}：${item.data.prefix}${item.data.value}${item.data.suffix}`);
                  }
                });
                // 分割线
                let divider = '';
                if (data.length > 0 && periodData.length > 0) {
                  divider = '<div style="background: #999; height: 2px; margin: 6px 0;"></div>';
                }
                return `<div style="min-width: 180px;">${data.join('<br/>')}${divider}${periodData.join('<br/>')}</div>`;
              },
              position: function(point, params, dom, rect, size) {
                if (point[0] + size.contentSize[0] + 30 > size.viewSize[0]) {
                  return [point[0] - size.contentSize[0] - 30, '15%'];
                }
                return [point[0] + 20, '15%'];
              },
            },
            legend: {
              itemGap: 50,
              icon: "rect",
              itemWidth: 15,
              itemHeight: 3,
              data: [],
              textStyle: {
                color: '#888',
                padding: [2, 0, 0, 0],
              }
            },
            grid: {
              top: 32,
              left: '2%',
              right: '2%',
              bottom: '0%',
              containLabel: true
            },
            xAxis: {
              axisLabel: {
                color: "#32393d"
              },
              axisLine: {
                lineStyle: {
                  color: "#32393d"
                }
              },
              data: [],
            },
            yAxis: {
              name: "",
              position: "left",
              axisLabel: {
                margin: 4,
                formatter: function (e) {
                  let t = Math.abs(e);
                  return t >= 1e4 && t < 1e7 ?
                    t = t / 1e4 + "万" :
                    t >= 1e7 && (t = t / 1e7 + "千万"), t;
                },
                color: "#32393d"
              },
              splitLine: {
                lineStyle: {
                  color: "#e5e9f2"
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#FFF"
                }
              }
            },
            series: []
          };
          this.chart.setOption(option);
          // 联动配置
          this.chart.group = 'dashboardReportGroup';
          this.$echarts.connect('dashboardReportGroup');
          window.addEventListener("resize", () => {
            this.chart.resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
            this.$echarts.disconnect('dashboardReportGroup');
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";
  .gj-card{
    // border-right: 0;
  }
  /deep/ .title-box2{
    margin-left: auto;
  }
  .gj-card:first-child{
    border-radius: 2px 0 0 2px;
  }
  .gj-card:last-child{
    border-right: 1px solid #D8DADD;
    border-radius: 0 2px 2px 0;
  }
  .dashboard-area{
    padding-top: 0;
    padding-left: 11px;
  }
  .dashboard-area--title{
    font-size: 14px;
    font-weight: 400;
  }
</style>

